import type { GetIndicatorAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetIndicatorAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetIndicatorAuditByIdArgs = {
  id: string;
};

export const useGetIndicatorAuditById = createQueryHook<
  UseGetIndicatorAuditByIdArgs,
  GetIndicatorAuditByIdResponseRow[],
  AuditLogQueryResult<'indicator_audit', GetIndicatorAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIndicatorAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator_audit: data }),
  graphqlDocument: GetIndicatorAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
